<div
  class="outerBox"
  [ngClass]="lightBackground === true ? 'light' : ''"
  [ngStyle]="xScrollMinWidth ? { 'min-width.px': xScrollMinWidth } : ''"
>
  <div
    *ngIf="!noHeader"
    class="d-flex boxHeader justify-content-between align-items-center"
  >
    <h2 *ngIf="!filters">
      <span class="heading">
        <ng-content select=".heading"></ng-content>
      </span>
      <span class="sub-heading">
        <ng-content select=".sub-heading"></ng-content>
      </span>
    </h2>
    <div *ngIf="downloadSection" class="download-section flex-grow-1">
      <ng-content select=".download"></ng-content>
    </div>
    <div *ngIf="filters" class="filters">
      <ng-content select=".filters"></ng-content>
    </div>
    <div class="headingAction" [class.headerSearch]="headerSearch">
      <ng-content select=".headingAction"></ng-content>
    </div>
    <div *ngIf="headerLinkRight">
      <button
        class="btn-link"
        [ngClass]="headerLinkRightDisabled ? 'disabled' : ''"
        (click)="clickHeaderLinkRight()"
      >
        {{ headerLinkRight }}
      </button>
    </div>
    <div *ngIf="headerDateStringRight">
      <div class="headerDateStringRight">
        As of {{ headerDateStringRight | date: "dd-MMM-yy" }}
      </div>
    </div>
  </div>
  <div
    class="innerBox"
    [class.no-padding]="noPadding"
    [class.no-header]="noHeader"
    [class.no-scrollbar]="noScrollBar"
    [class.no-scroll]="noScroll"
    [class.tableContainer]="tableContainer"
    [class.light-inner]="lightBackgroundInnerBoxOnly"
  >
    <app-dc-loading
      *ngIf="loading"
      [lightBackground]="lightBackground"
    ></app-dc-loading>
    <ng-content></ng-content>
  </div>
</div>
